'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curr_generated = require('./generated/curr_generated');

var _curr_generated2 = _interopRequireDefault(_curr_generated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _curr_generated2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@xdbchain/js-stellar-base/lib/xdr.js
// module id = 4
// module chunks = 0